import React from 'react'
import "./About.css"
import Header from './Header'
import imgPotfolio from "./images/profile-1.JPG"
import TypeAnimation from 'react-type-animation';

const About = () => {

  const ExampleComponent = () => {
    return (
      <TypeAnimation
        cursor={false}
        sequence={['React typing animation based on typical', 1000, '']}
        wrapper="h2"
      />
    );
  };

  return (
    <div>
        
          <div className="about">

            <h1 className="about__header">
              About-me
            </h1>

            <div className="about__me">
              <img  className="image__profile" src={imgPotfolio} alt="Edward Ndlovu" />

              <div className="about__about">

              <p className="about_intro">
                 I'm Edward and I'm a <span className="typing__info">{ExampleComponent}</span>
                <div className="typing__about" style={{ width: '20em' }} >
                    <TypeAnimation
                    cursor={true}
                    sequence={[
                    'YouTuber',
                        2000,
                    'Developer.',
                        2000,
                    'Designer',
                        2000,
                    'Freelancer',
                        2000
                    ]}
                    wrapper="h2"
                    repeat={Infinity}
                    />
                </div>
              </p>
                <p>I am a self taught Full-Stack Developer. 
                My passion for coding began in 2018 when I fell in love with the idea
                of telling a computer what to do. I began to quench my thirst for programming 
                knowledge and skills. <br />
                Technologies I use include Python, Javascript, Node.js, HTML, CSS and React
                <br />I am a well disciplined, team player and punctual individual.
                <br />One of my favourite focus in programming is Data structures and 
                Algorithms. Solving problems from a different pespective is so much fascinating
                for me. My current goal is to keep learning and getting better than who I was
                yesterday.
             

                .</p>
              </div>
            </div>
            
          </div>
        
    </div>
  )
}

export default About